import {CrudService} from "../../core/common/crud-service";
import {MemberCheckResponseItem} from "../../../model/other/dto/other-api";

export class OtherService extends CrudService {
    protected readonly basePath = '/api/membership';

    /**
     * 查詢會員級數檢核資料
     * @param request
     */
    async getMemberChekList(): Promise<MemberCheckResponseItem[] | null> {
        return this.customGet<MemberCheckResponseItem[]>('getMemberChekList');
    }

}

export const otherService = new OtherService();